(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (deviceIsMobile.matches) {
    const footerLinks = document.querySelectorAll('.footer-link');
    footerLinks.forEach((link) => {
      const mobileLink = link.getAttribute('data-mobile-link');
      if (mobileLink) {
        link.setAttribute('href', mobileLink);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-right"]) return;
  try {
    
/*
 Sticky-kit v1.1.2 | WTFPL | Leaf Corcoran 2015 | http://leafo.net
*/
(function(){var b,f;b=this.jQuery||window.jQuery;f=b(window);b.fn.stick_in_parent=function(d){var A,w,J,n,B,K,p,q,k,E,t;null==d&&(d={});t=d.sticky_class;B=d.inner_scrolling;E=d.recalc_every;k=d.parent;q=d.offset_top;p=d.spacer;w=d.bottoming;null==q&&(q=0);null==k&&(k=void 0);null==B&&(B=!0);null==t&&(t="is_stuck");A=b(document);null==w&&(w=!0);J=function(a,d,n,C,F,u,r,G){var v,H,m,D,I,c,g,x,y,z,h,l;if(!a.data("sticky_kit")){a.data("sticky_kit",!0);I=A.height();g=a.parent();null!=k&&(g=g.closest(k));
if(!g.length)throw"failed to find stick parent";v=m=!1;(h=null!=p?p&&a.closest(p):b("<div />"))&&h.css("position",a.css("position"));x=function(){var c,f,e;if(!G&&(I=A.height(),c=parseInt(g.css("border-top-width"),10),f=parseInt(g.css("padding-top"),10),d=parseInt(g.css("padding-bottom"),10),n=g.offset().top+c+f,C=g.height(),m&&(v=m=!1,null==p&&(a.insertAfter(h),h.detach()),a.css({position:"",top:"",width:"",bottom:""}).removeClass(t),e=!0),F=a.offset().top-(parseInt(a.css("margin-top"),10)||0)-q,
u=a.outerHeight(!0),r=a.css("float"),h&&h.css({width:a.outerWidth(!0),height:u,display:a.css("display"),"vertical-align":a.css("vertical-align"),"float":r}),e))return l()};x();if(u!==C)return D=void 0,c=q,z=E,l=function(){var b,l,e,k;if(!G&&(e=!1,null!=z&&(--z,0>=z&&(z=E,x(),e=!0)),e||A.height()===I||x(),e=f.scrollTop(),null!=D&&(l=e-D),D=e,m?(w&&(k=e+u+c>C+n,v&&!k&&(v=!1,a.css({position:"fixed",bottom:"",top:c}).trigger("sticky_kit:unbottom"))),e<F&&(m=!1,c=q,null==p&&("left"!==r&&"right"!==r||a.insertAfter(h),
h.detach()),b={position:"",width:"",top:""},a.css(b).removeClass(t).trigger("sticky_kit:unstick")),B&&(b=f.height(),u+q>b&&!v&&(c-=l,c=Math.max(b-u,c),c=Math.min(q,c),m&&a.css({top:c+"px"})))):e>F&&(m=!0,b={position:"fixed",top:c},b.width="border-box"===a.css("box-sizing")?a.outerWidth()+"px":a.width()+"px",a.css(b).addClass(t),null==p&&(a.after(h),"left"!==r&&"right"!==r||h.append(a)),a.trigger("sticky_kit:stick")),m&&w&&(null==k&&(k=e+u+c>C+n),!v&&k)))return v=!0,"static"===g.css("position")&&g.css({position:"relative"}),
a.css({position:"absolute",bottom:d,top:"auto"}).trigger("sticky_kit:bottom")},y=function(){x();return l()},H=function(){G=!0;f.off("touchmove",l);f.off("scroll",l);f.off("resize",y);b(document.body).off("sticky_kit:recalc",y);a.off("sticky_kit:detach",H);a.removeData("sticky_kit");a.css({position:"",bottom:"",top:"",width:""});g.position("position","");if(m)return null==p&&("left"!==r&&"right"!==r||a.insertAfter(h),h.remove()),a.removeClass(t)},f.on("touchmove",l),f.on("scroll",l),f.on("resize",
y),b(document.body).on("sticky_kit:recalc",y),a.on("sticky_kit:detach",H),setTimeout(l,0)}};n=0;for(K=this.length;n<K;n++)d=this[n],J(b(d));return this}}).call(this);


    if ($(window).width() > 990) {    
        $("#shopify-section-holiday-left").stick_in_parent({offset_top: 130});
    }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  function scrollToHashOnSmallDevices() {
      if (window.innerWidth < 991) {
          const url = window.location.href;

          // Check if the URL contains a "?"

              // Extract the hash manually from the URL
              const hashIndex = url.indexOf('#');
              if (hashIndex !== -1) {
                  const hash = url.substring(hashIndex).split('?')[0];

                  // Find the element with the corresponding ID
                  const targetElement = document.querySelector(hash);

                  // If the element exists, scroll to it instantly
                  if (targetElement) {
                      targetElement.scrollIntoView({ behavior: 'instant' });
                  }
              }

      }
  }

  // Call the function
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      scrollToHashOnSmallDevices();
    }, 300);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-with-blocks"] && !Shopify.designMode) return;
  try {
    
  function scrollToHashOnSmallDevices() {
      if (window.innerWidth < 991) {
          const url = window.location.href;

          // Check if the URL contains a "?"

              // Extract the hash manually from the URL
              const hashIndex = url.indexOf('#');
              if (hashIndex !== -1) {
                  const hash = url.substring(hashIndex).split('?')[0];

                  // Find the element with the corresponding ID
                  const targetElement = document.querySelector(hash);

                  // If the element exists, scroll to it instantly
                  if (targetElement) {
                      targetElement.scrollIntoView({ behavior: 'instant' });
                  }
              }

      }
  }

  // Call the function
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      scrollToHashOnSmallDevices();
    }, 300);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosto-collection"] && !Shopify.designMode) return;
  try {
    
  function initNostoCollectionPreload() {
    const url = new URL(window.location.href);
    if (url.hash) {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    }
  
  
    // Handle skeleton grid
    const skeletonGrid = document.getElementById('skeleton-grid');
    const serpContainer = document.getElementById('serp');
  
    // Function to check if #serp has content
    function checkSerpContent() {
      if (!serpContainer || !skeletonGrid) return;

      const hasProducts = !!serpContainer.querySelector('.nosto-product-grid product-card');
      const hasNoResults =
        !!serpContainer.querySelector('[data-nosto-element="category"]') &&
        !serpContainer.querySelector('.nosto-product-grid');

      if (hasProducts || hasNoResults) {
        skeletonGrid.classList.add('is-hidden');
      }
    }

    // Number each nosto-dynamic-card in grid order so third parties can target
    // a specific card position (e.g. .nosto-card-3). Re-runs on every grid
    // mutation since Nosto re-renders #serp on filter/sort/paging, so stale
    // numbering is stripped before the current position is reapplied.
    function numberNostoDynamicCards() {
      if (!serpContainer) return;
      const cards = serpContainer.querySelectorAll('nosto-dynamic-card');
      cards.forEach((card, index) => {
        Array.from(card.classList)
          .filter((className) => /^nosto-card-\d+$/.test(className))
          .forEach((className) => card.classList.remove(className));
        card.classList.add(`nosto-card-${index + 1}`);
      });
    }

    // Use MutationObserver to watch for content being added to #serp
    if (serpContainer) {
      const observer = new MutationObserver((mutations) => {
        checkSerpContent();
        numberNostoDynamicCards();
      });
  
      observer.observe(serpContainer, {
        childList: true,
        subtree: true
      });
  
      // Also check immediately in case content is already there
      checkSerpContent();
      setTimeout(() => skeletonGrid?.classList.add('is-hidden'), 10000);
      numberNostoDynamicCards();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNostoCollectionPreload, { once: true });
  } else {
    initNostoCollectionPreload();
  }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upcoming-events"]) return;
  try {
    
    function scrollToHashOnSmallDevices() {
        if (window.innerWidth < 991) {
            const url = window.location.href;
            
            // Check if the URL contains a "?"
            if (url.includes('?')) {
                // Extract the hash manually from the URL
                const hashIndex = url.indexOf('#');
                if (hashIndex !== -1) {
                    const hash = url.substring(hashIndex).split('?')[0];

                    // Find the element with the corresponding ID
                    const targetElement = document.querySelector(hash);
                    
                    // If the element exists, scroll to it instantly
                    if (targetElement) {
                        targetElement.scrollIntoView({ behavior: 'instant' });
                    }
                }
            }
        }
    }

    // Call the function
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(function() {
        scrollToHashOnSmallDevices();
      }, 300);
    });

    
  } catch(e) { console.error(e); }
})();
})();
